/**
 * Components: Checkout cart count
 * ------------------------------------------------------------------------------
 * Set number of items in cart.
 *
 * @namespace checkoutCount
 */

import axios from 'axios';

/**
 * DOM selectors.
 */
const selectors = {
  toggleIcon: '.order-summary-toggle__icon-wrapper',
  count: '[js-checkout="count"]',
};

/*
* Create a new collection filter instance.
*/
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    count: document.querySelector(selectors.count),
    toggleIcon: document.querySelector(selectors.toggleIcon),
  };

  function setCartCount() {
    axios.get(`/cart.js?no-cache=${new Date().getTime()}`)
      .then((response) => {
        if (!nodeSelectors.count) {
          nodeSelectors.toggleIcon.innerHTML += `
            <span class="order-summary-toggle__count" js-checkout="count">
              ${response.data.item_count}
            </span>`;
        }
      })
      .catch((error) => {
        throw new Error(error);
      });
  }

  function init() {
    setCartCount();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
